module.exports = __webpack_public_path__ + "media/images/icons/icon_bullet_red-7e07221f1c694326226fcf559d1aa956.svg";